import { getHubProfileStorageService } from "@/infrastructure/di/services";
import { useHubProfileStore } from "@/stores/useHubProfileStore";

/**
 * Hydrates the hub-profile store from HubProfileStorageService. The selected
 * profile is shared localStorage state (HubRepository and the hub hooks
 * read/write it through the service), so the store cannot own persistence via
 * zustand middleware. Kept out of the store itself so the store stays a pure
 * state container (no infrastructure imports).
 */
export function initHubProfileStore() {
  useHubProfileStore.setState({
    selectedProfileUuid: getHubProfileStorageService().getSelectedProfileUuid(),
  });
}
